<template>
  <div
    v-if="onForDelivery.length > 0"
    class="text-center"
  >
    <el-table
      size="mini"
      :data="visibleOnForDelivery"
      stripe
      style="width: 100%"
    >
      <el-table-column
        label="Consignment"
        width="140"
      >
        <template slot-scope="scope">
          <a
            :href="getTrackingLink(scope.row.id)"
            target="_top"
          >
            {{ scope.row.consignment }}
          </a>
        </template>
      </el-table-column>

      <el-table-column
        prop="receiver"
        label="Receiver"
        min-width="120"
        show-overflow-tooltip
      />
    </el-table>

    <div class="clearfix" />

    <el-pagination
      class="pt-4 w-100 text-center"
      layout="prev, pager, next"
      :pager-count="5"
      :page-size="pageSize"
      :current-page.sync="currentPage"
      :total="totalOnForDelivery"
      small
      background
      hide-on-single-page
      @current-change="setCurrentPage"
    />
  </div>

  <div
    v-else
    class="text-center text-muted font-italic p-3"
  >
    No Data
  </div>
</template>

<script>
export default {
  props: {
    onForDelivery: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      pageSize: 6,
      currentPage: 1
    }
  },
  computed: {
    totalOnForDelivery () {
      return this.onForDelivery.length
    },
    visibleOnForDelivery () {
      const currentPage = this.currentPage
      const pageSize = this.pageSize
      const onForDelivery = this.onForDelivery

      return onForDelivery.slice((currentPage - 1) * pageSize, currentPage * pageSize)
    }
  },
  methods: {
    formatNumber (value) {
      return (new Intl.NumberFormat('en-US')).format(value)
    },
    getTrackingLink (id) {
      return process.env.VUE_APP_LEGACY_SHIPPER_URI + 'track/' + id
    },
    setCurrentPage (page) {
      this.currentPage = page
    }
  }
}
</script>
